import { useCheckVersion } from "./useCheckVersion";
export const BackgroundHooks = () => {
  useCheckVersion();
  return <></>;
};
